import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Link, Breadcrumbs, Typography, Stepper, Step, StepLabel } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom'

import { useSelector } from 'react-redux';

import { MenuSteps } from '../constants/config'

const useStyles = makeStyles((theme) => ({
    wrap: {
        width: '100%',
        padding: '5px',
        marginTop: '20px',
        marginBottom: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
    }
}));

// ステップ
function PageStep(props){
    const classes = useStyles();

    const [activeStep, setActiveStep] = useState(props.activeStep);

    return(
        <div id="page_top" className={classes.wrap}>
            <Stepper activeStep={activeStep}>
                {
                    MenuSteps.map((label, index) => {
                        return (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        );
                    })
                }
            </Stepper>
        </div>
    );
}

export default PageStep
